export const translations = {
  en: {
    // Nav
    nav_home: "Home",
    nav_about: "About",
    nav_projects: "Projects",
    nav_skills: "Skills",
    nav_services: "Services",
    nav_experience: "Experience",
    nav_contact: "Contact",
    nav_back: "Back to Home",
    // Hero
    hero_greeting: "👋 Hello, I'm",
    hero_name: "Mahmood Al-Aqaad",
    hero_desc: "I craft beautiful, responsive, and user-centric web experiences using modern technologies. Specializing in React, Next.js, and cutting-edge frontend development.",
    hero_cv: "Go to My CV",
    hero_talk: "Let's Talk",
    hero_typed_strings: ['Front-End Developer', 'React Developer', 'Next.js Developer', 'FullStack Developer'],
    // About
    about_title_1: "About",
    about_title_2: "Me",
    about_subtitle: "Passionate Front-End Developer",
    about_p1: "Hello! I'm Mahmood Aqaad, a dedicated front-end developer with a passion for creating seamless and engaging web experiences. I specialize in building modern, responsive applications using cutting-edge technologies like React, Next.js, and TypeScript.",
    about_p2: "My journey in web development has equipped me with a strong foundation in both fundamental technologies (HTML, CSS, JavaScript) and modern frameworks. I take pride in writing clean, maintainable code and staying current with industry best practices.",
    about_p3: "Beyond coding, I'm committed to continuous learning and growth. I believe in the power of collaboration and am always excited to work on projects that challenge me to push the boundaries of what's possible on the web.",
    about_stat_projects: "Projects Completed",
    about_stat_experience: "Years Experience",
    about_stat_satisfaction: "Client Satisfaction",
    // Projects
    projects_title_1: "My",
    projects_title_2: "Projects",
    projects_all: "All",
    projects_react: "React",
    projects_fullstack: "Full Stack",
    projects_html: "HTML/CSS/JS",
    projects_view_details: "View Details",
    projects_live_demo: "Live Demo",
    projects_show_all: "show All",
    // Skills
    skills_title_1: "My",
    skills_title_2: "Skills",
    // Services
    services_title_1: "My",
    services_title_2: "Services",
    services_subtitle: "Professional solutions for modern web challenges",
    // Stats
    stats_title: "By The Numbers",
    stats_subtitle: "Measurable impact and technical excellence",
    // Contact
    contact_title_1: "Get In",
    contact_title_2: "Touch",
    contact_discuss: "Let's discuss your project",
    contact_desc: "I'm always open to discussing new projects, creative ideas or opportunities to be part of your visions.",
    contact_email_me: "Email Me",
    contact_phone: "Phone",
    contact_location: "Location / Address",
    contact_location_val: "Gaza, Palestine",
    contact_connect: "Connect with me",
    contact_name_label: "Your Name",
    contact_email_label: "Your Email",
    contact_phone_label: "Phone Number",
    contact_subject_label: "Subject",
    contact_message_label: "Message",
    contact_message_placeholder: "Tell me about your project...",
    contact_success: "Message sent successfully! I will get back to you soon.",
    contact_error: "Oops! Something went wrong. Please try again later.",
    contact_send: "Send Message",
    contact_sending: "Sending...",
    // Footer
    footer_rights: "All rights reserved.",
    footer_built_with: "Built with Mahmood using React & CSS",
    // Single Project
    single_back: "Back to Projects",
    single_overview: "Project Overview",
    single_features: "Key Features",
    single_tech_used: "Technologies Used",
    single_category: "Category",
    single_responsive: "Responsive",
    single_yes: "Yes",
    single_no: "No",
    single_fullstack: "Full Stack",
    single_frontend: "Frontend",
    single_live_demo: "Live Demo",
    single_source_code: "Source Code"
  },
  ar: {
    // Nav
    nav_home: "الرئيسية",
    nav_about: "عني",
    nav_projects: "مشاريعي",
    nav_skills: "مهاراتي",
    nav_services: "خدماتي",
    nav_experience: "إحصائيات",
    nav_contact: "تواصل معي",
    nav_back: "العودة للرئيسية",
    // Hero
    hero_greeting: "👋 مرحباً، أنا",
    hero_name: "محمود العقاد",
    hero_desc: "أقوم بصناعة تجارب ويب جميلة ومستجابة ومتمحورة حول المستخدم باستخدام تقنيات حديثة. متخصّص في تطوير React و Next.js وواجهات المستخدم الحديثة.",
    hero_cv: "سيرتي الذاتية",
    hero_talk: "دعنا نتحدث",
    hero_typed_strings: ['مطور واجهات أمامية', 'مطور ريآكت (React)', 'مطور نكست جي إس (Next.js)', 'مطور ويب متكامل (FullStack)'],
    // About
    about_title_1: "عني",
    about_title_2: "أنا",
    about_subtitle: "مطور واجهات أمامية شغوف",
    about_p1: "أهلاً بك! أنا محمود العقاد، مطور واجهات أمامية متخصص في إنشاء تجارب ويب سلسة وجذابة. أركز على بناء تطبيقات حديثة ومستجابة باستخدام أحدث التقنيات مثل React و Next.js و TypeScript.",
    about_p2: "لقد زودتني رحلتي في تطوير الويب بأساس متين في التقنيات الأساسية (HTML، CSS، JavaScript) بالإضافة إلى الأطر البرمجية الحديثة. أفتخر بكتابة كود نظيف وقابل للصيانة ومواكبة أفضل ممارسات الصناعة.",
    about_p3: "إلى جانب البرمجة، أنا ملتزم بالتعلم المستمر والنمو. أؤمن بقوة التعاون وأتحمس دائماً للعمل على مشاريع تتحداني لتجاوز حدود الممكن على الويب.",
    about_stat_projects: "مشروع منجز",
    about_stat_experience: "سنوات الخبرة",
    about_stat_satisfaction: "رضا العملاء",
    // Projects
    projects_title_1: "مشاريعي",
    projects_title_2: "المميزة",
    projects_all: "الكل",
    projects_react: "ريآكت",
    projects_fullstack: "ويب متكامل",
    projects_html: "HTML/CSS/JS",
    projects_view_details: "عرض التفاصيل",
    projects_live_demo: "العرض المباشر",
    projects_show_all: "عرض الكل",
    // Skills
    skills_title_1: "مهاراتي",
    skills_title_2: "التقنية",
    // Services
    services_title_1: "خدماتي",
    services_title_2: "المهنية",
    services_subtitle: "حلول احترافية لتحديات الويب الحديثة",
    // Stats
    stats_title: "بالأرقام",
    stats_subtitle: "تأثير ملموس وتميز تقني",
    // Contact
    contact_title_1: "تواصل",
    contact_title_2: "معي",
    contact_discuss: "لنناقش مشروعك",
    contact_desc: "أنا متاح دائماً لمناقشة المشاريع الجديدة أو الأفكار الإبداعية أو الفرص لتجسيد رؤيتك على أرض الواقع.",
    contact_email_me: "راسلني بريدياً",
    contact_phone: "الهاتف",
    contact_location: "الموقع / العنوان",
    contact_location_val: "غزة، فلسطين",
    contact_connect: "تواصل معي عبر",
    contact_name_label: "الاسم الكامل",
    contact_email_label: "البريد الإلكتروني",
    contact_phone_label: "رقم الهاتف",
    contact_subject_label: "الموضوع",
    contact_message_label: "الرسالة",
    contact_message_placeholder: "أخبرني بالمزيد عن مشروعك...",
    contact_success: "تم إرسال الرسالة بنجاح! سأتواصل معك قريباً.",
    contact_error: "عذراً! حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً.",
    contact_send: "إرسال الرسالة",
    contact_sending: "جاري الإرسال...",
    // Footer
    footer_rights: "جميع الحقوق محفوظة.",
    footer_built_with: "صنع بواسطة محمود باستخدام React & CSS",
    // Single Project
    single_back: "العودة للمشاريع",
    single_overview: "نظرة عامة على المشروع",
    single_features: "المميزات الرئيسية",
    single_tech_used: "التقنيات المستخدمة",
    single_category: "التصنيف",
    single_responsive: "مستجيب",
    single_yes: "نعم",
    single_no: "لا",
    single_fullstack: "ويب متكامل",
    single_frontend: "واجهات أمامية",
    single_live_demo: "العرض المباشر",
    single_source_code: "كود المصدر"
  }
};
